export const isLogin = () => {
  if (localStorage.getItem("Api_key")) {
    return true;
  }
  return false;
};
